import React, { memo } from "react";
import { inject, observer } from "mobx-react";
import _ from "lodash";
import {
  FormGroup,
  InputGroup,
  FormControl,
  Button,
  Glyphicon,
  ControlLabel,
  DropdownButton,
  MenuItem,
} from "react-bootstrap";
import moment from "moment";
import { withRouter } from "../../utils/Utils";

import { SEARCH_AUTOCOMPLETE_START_CHAR_COUNT } from "../../stores/SearchStore";

@inject("searchStore")
@observer
class SearchBarComponent extends React.Component {
  state = {
    isInput: false,
    arrowSelectedSuggestionIndex: undefined,
    areSuggestionsOvered: false,
  };

  areSuggestionsDisplayed = false;
  maxSuggestionsDisplayed = 10;
  suggestionsToDisplay = [];

  searchBarInputRef = React.createRef();
  suggestionsBoxRef = React.createRef();

  componentDidMount() {
    this.handleEventListenerRegistrationForSuggestionNavigation(true);
  }

  componentDidUpdate(prevProps, prevState) {
    const { frameworks } = this.props;
    const {
      getSelectedCubeTypes,
      getSelectedUserProfile,
      setSelectedFramework,
    } = this.props.searchStore;

    if (!!this.suggestionsBoxRef.current) {
      this.suggestionsBoxRef.current.addEventListener(
        "mouseenter",
        this.handleSuggestionMouseEnterEvent
      );
      this.suggestionsBoxRef.current.addEventListener(
        "mouseleave",
        this.handleSuggestionMouseLeaveEvent
      );
    }

    if (getSelectedUserProfile && getSelectedUserProfile.id === "full") return;
    if (prevProps.frameworks !== frameworks) {
      const cubeTypesOfFrameworks = [];
      frameworks.forEach((framework) => {
        Object.keys(framework.cubeCountsByType).forEach((key) => {
          if (!cubeTypesOfFrameworks.includes(key)) {
            cubeTypesOfFrameworks.push(key);
          }
        });
      });
      const intersection = getSelectedCubeTypes.filter((value) =>
        cubeTypesOfFrameworks.includes(value)
      );
      // reset the selected framework in the search bar only if the selected profile does not have it
      if (intersection.length < 1) {
        setSelectedFramework(undefined);
      }
    }
  }

  componentWillUnmount = () => {
    if (!!this.suggestionsBoxRef.current) {
      this.suggestionsBoxRef.current.removeEventListener(
        "mouseenter",
        this.handleSuggestionMouseEnterEvent
      );
      this.suggestionsBoxRef.current.removeEventListener(
        "mouseleave",
        this.handleSuggestionMouseLeaveEvent
      );
    }

    this.handleEventListenerRegistrationForSuggestionNavigation(false);
  };

  handleFocus = () => {
    this.setState({ isInput: true });
  };

  handleBlur = () => {
    this.setState({ isInput: false });
  };

  getUrl(type, tid) {
    return `/view/${type}/${tid}`;
  }

  handleSuggestionMouseEnterEvent = () => {
    this.setState({ areSuggestionsOvered: true });
  }

  handleSuggestionMouseLeaveEvent = () => {
    this.setState({ areSuggestionsOvered: false });
  }

  handleEventListenerRegistrationForSuggestionNavigation(useToRegister) {
    if (!this.searchBarInputRef || !this.searchBarInputRef.current) return;

    if(useToRegister) {
      this.searchBarInputRef.current.addEventListener(
        "keydown",
        (event) => this.handleSuggestionsNavigation(event)
      )
    } else {
      this.searchBarInputRef.current.removeEventListener(
        "keydown",
        (event) => this.handleSuggestionsNavigation(event)
      )
    }
  }

  handleSuggestionsNavigation = (event) => {
    if(!this.areSuggestionsDisplayed) {
      return;
    }
    if(!event.isComposing && !event.repeat && (event.keyCode ?? event.keyCode) === 40) {
      event.preventDefault()
      // arrow down
      let newSelectedIndex;
      if(this.state.arrowSelectedSuggestionIndex === this.suggestionsToDisplay.length - 1) {
        newSelectedIndex = undefined; // on last elem, unselect suggestion to 'go back on input field'
      } else if(this.state.arrowSelectedSuggestionIndex !== undefined){
        newSelectedIndex = this.state.arrowSelectedSuggestionIndex >= this.suggestionsToDisplay.length -1 ? 0 : this.state.arrowSelectedSuggestionIndex + 1;
      } else {
        newSelectedIndex = 0; // no elem chosen yet case
      }
      this.setState({ arrowSelectedSuggestionIndex: newSelectedIndex });
    } else if(!event.isComposing && !event.repeat && (event.keyCode ?? event.keyCode) === 38) {
      event.preventDefault()
      // arrow up
      let newSelectedIndex;
      if(this.state.arrowSelectedSuggestionIndex === 0){
        newSelectedIndex = undefined; // on first elem, unselect suggestion to 'go back on input field'
      }else if(this.state.arrowSelectedSuggestionIndex !== undefined){
        newSelectedIndex = this.state.arrowSelectedSuggestionIndex === 0 ? this.suggestionsToDisplay.length - 1 : this.state.arrowSelectedSuggestionIndex - 1;
      } else {
        newSelectedIndex = this.suggestionsToDisplay.length - 1; // no elem chosen yet case
      }
      this.setState({ arrowSelectedSuggestionIndex: newSelectedIndex });
    } else if(!event.isComposing && !event.repeat && (event.keyCode ?? event.keyCode) === 13 && this.state.arrowSelectedSuggestionIndex !== undefined) {
      // enter
      event.preventDefault()
      this.handleSuggestionItemsClick(event, this.suggestionsToDisplay[this.state.arrowSelectedSuggestionIndex])
    } else if(!event.isComposing && !event.repeat && (event.keyCode ?? event.keyCode) === 27) {
      // escape - close the suggestions panel
      event.preventDefault()
      this.setState({ isInput: false, arrowSelectedSuggestionIndex: undefined })
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const {
      searchQuery,
      setPage,
      getSelectedFramework,
      getSelectedTypes,
      getSelectedDate,
      fetchSearchResults,
    } = this.props.searchStore;
    if (!searchQuery) return;
    this.handleSuggestionMouseLeaveEvent();
    fetchSearchResults();
    this.handleBlur();
    setPage(1);
    this.props.navigate({
      pathname: "/search",
      state: { pathname: "/search" },
      search:
        "?" +
        new URLSearchParams({
          search: searchQuery ? encodeURI(searchQuery) : "",
          framework: getSelectedFramework
            ? encodeURI(getSelectedFramework.frameworkId)
            : "all",
          types: getSelectedTypes.map((type) => encodeURI(type)) || [],
          validityDate: getSelectedDate
            ? moment(getSelectedDate).format("YYYY-MM-DD")
            : "",
        }),
    });

    // this.props.history.push({
    //   pathname: "/search",
    //   search:
    //     "?" +
    //     new URLSearchParams({
    //       search: searchQuery ? encodeURI(searchQuery) : "",
    //       framework: getSelectedFramework
    //         ? encodeURI(getSelectedFramework.frameworkId)
    //         : "all",
    //       types: getSelectedTypes.map((type) => encodeURI(type)) || [],
    //       validityDate: getSelectedDate
    //         ? moment(getSelectedDate).format("YYYY-MM-DD")
    //         : "",
    //     }),
    // });
  };

  handleSuggestionItemsClick(e, searchValue) {
    const { setSearchQuery, setLastSearchQuery } = this.props.searchStore;
    setSearchQuery(searchValue);
    setLastSearchQuery(searchValue);
    this.handleSubmit(e);
    this.handleBlur();
  }

  getFrameworkOptions = (frameworks) => {
    const { getSelectedFramework, setSelectedFramework } =
      this.props.searchStore;
    if (!frameworks || frameworks.length < 1) return null;
    return frameworks
      .sort((f1, f2) => {
        if (f1.name > f2.name) return 1;
        if (f2.name > f1.name) return -1;
        return 0;
      })
      .map((framework) => (
        <MenuItem
          key={framework.code}
          value={framework.tid}
          onSelect={() => setSelectedFramework(framework)}
          active={
            getSelectedFramework && getSelectedFramework.tid === framework.tid
          }
          title={framework.code}
          className={
            framework.type === "Framework"
              ? framework.maintenanceAgencyId === "ECB"
                ? "ref"
                : "nonref"
              : ""
          }
        >
          {framework.name}
        </MenuItem>
      ));
  };
  handler = _.debounce(async () => {
    const {
      searchQuery,
      fetchSearchMetadata,
      fetchSearchAutocompleteResults,
    } = this.props.searchStore;
    if (searchQuery.length > SEARCH_AUTOCOMPLETE_START_CHAR_COUNT)
      fetchSearchMetadata().then(() => {
        fetchSearchAutocompleteResults();
        this.setState({ arrowSelectedSuggestionIndex: undefined })
      });
  }, 600);

  debouceRequest = (value) => this.handler(value);

  onKeyUp = (e) => {
    const { onSearchQueryChange } = this.props.searchStore;
    onSearchQueryChange(e);
    this.debouceRequest();
    this.setState({ arrowSelectedSuggestionIndex: undefined, isInput: true })
  };

  render() {
    const { frameworks } = this.props;
    const {
      searchQuery,
      filtersVisible,
      toggleFilters,
      getSelectedFramework,
      setSelectedFramework,
      getMicroFrameworks,
      getMacroFrameworks,
      getEbaFrameworks,
      getAutocompleteResults,
      getMacroFrameworksMaintenanceAgencies,
    } = this.props.searchStore;

    const frameworkOptions = [...frameworks];

    if (getMicroFrameworks.length > 0) {
      frameworkOptions.push({
        code: getMicroFrameworks.map((fw) => fw.code).join(", "),
        description: "Micro Frameworks",
        frameworkId: "micro",
        maintenanceAgencyId: "",
        name: "Micro Frameworks",
        tid: "micro",
        type: "FrameworkGroup",
        groupTids: getMicroFrameworks.map((fw) => fw.tid),
      });
    }

    if (getMacroFrameworks.length > 0) {
      frameworkOptions.push({
        code: getMacroFrameworks.map((fw) => fw.code).join(", "),
        description: "Macro Frameworks non-reference",
        frameworkId: "macro",
        maintenanceAgencyId: "",
        name: "Macro Frameworks non-reference",
        tid: "macro",
        type: "FrameworkGroup",
        groupTids: getMacroFrameworks.map((fw) => fw.tid),
      });
    }

    if (getEbaFrameworks.length > 0) {
      frameworkOptions.push({
        code: getEbaFrameworks.map((fw) => fw.code).join(", "),
        description: "EBA ITS non-referece",
        frameworkId: "eba",
        maintenanceAgencyId: "",
        name: "EBA ITS non-reference",
        tid: "eba",
        type: "FrameworkGroup",
        groupTids: getEbaFrameworks.map((fw) => fw.tid),
      });
    }

    const maintenanceAgenciesToExclude = getMacroFrameworksMaintenanceAgencies;
    const ref = this.getFrameworkOptions(
      frameworkOptions.filter(
        (framework) =>
          framework.type === "Framework" &&
          framework.maintenanceAgencyId === "ECB" &&
          !maintenanceAgenciesToExclude.includes(framework.maintenanceAgencyId)
      )
    );

    const nonref = this.getFrameworkOptions(
      frameworkOptions.filter(
        (framework) =>
          framework.type === "Framework" &&
          framework.maintenanceAgencyId !== "ECB" &&
          !maintenanceAgenciesToExclude.includes(framework.maintenanceAgencyId)
      )
    );

    const groups = this.getFrameworkOptions(
      frameworkOptions.filter(
        (framework) => framework.type === "FrameworkGroup"
      )
    );

    const searchResults = getAutocompleteResults.results;
    const autocompleteMatches = getAutocompleteResults.autocompleteMatches;
    const propertyUsedToMatch =
      !!autocompleteMatches && autocompleteMatches.length > 0
        ? Object.keys(autocompleteMatches[0].valueForProperty)[0]
        : "";
    const inputWidth = this.searchBarInputRef?.current?.clientWidth;
    const autoCompleteWidth =
      !!inputWidth && inputWidth - 2 > 293 ? inputWidth - 2 : 293; // 293px is good on 1080p
    const styles = {
      autoComplete: {
        position: "absolute",
        marginLeft: "130px",
        flexDirection: "column",
        display: "flex",
        marginTop: "35px",
        overflowY: "auto",
        maxHeight: "50vh",
        width: `${autoCompleteWidth}px`,
        boxShadow: "1px 2px 9px #ccc",
        borderBottomLeftRadius: "10px",
        borderBottomRightRadius: "10px",
        backgroundColor: "white",
      },
      autoCompleteFilterOn: {
        position: "absolute",
        marginLeft: "130px",
        flexDirection: "column",
        display: "flex",
        marginTop: "92px",
        overflowY: "auto",
        maxHeight: "50vh",
        width: `${autoCompleteWidth}px`,
        boxShadow: "1px 2px 9px #ccc",
        borderRadius: "10px",
        backgroundColor: "white",
      },
      hideSuggestionsButton: {
        display: "flex",
        color: "#003299",
        width: "100%",
        justifyContent: "center",
        alignSelf: "center",
      },
      suggestionItem: {
        display: "flex",
        flexDirection: "column",
        padding: "5px",
      },
      suggestionLink: {
        display: "flex",
        flexDirection: "column",
        color: "black",
      },
    };
    const distinctMatches = (value, index, self, objectProperty) => {
      return (
        self
          .map((x) => x?.valueForProperty[objectProperty]?.toLowerCase())
          .indexOf(value?.valueForProperty[objectProperty]?.toLowerCase()) ===
        index
      );
    };

    this.areSuggestionsDisplayed = this.state.isInput &&
      searchResults?.length > 0 &&
      autocompleteMatches?.length > 0 &&
      searchQuery;

    this.suggestionsToDisplay = this.areSuggestionsDisplayed ? autocompleteMatches
      .filter((value, index, self) =>
        distinctMatches(value, index, self, propertyUsedToMatch)
      )
      .slice(0, this.maxSuggestionsDisplayed)
      .map(match => {
        const propertyForValue = match?.valueForProperty;
        return Object.values(propertyForValue).find((value) => !!value).toLowerCase();
      }) : [];  

    return (
      <div className="search-bar-wrapper">
        <form onSubmit={this.handleSubmit}>
          <FormGroup className="search-bar">
            <InputGroup>
              <DropdownButton
                closeonchange={"true"}
                id={"framework-search"}
                title={(() => {
                  let label = "All Frameworks";
                  if (getSelectedFramework) {
                    const target = frameworkOptions.find(
                      (framework) => framework.tid === getSelectedFramework.tid
                    );
                    if (target) {
                      label = target.name;
                    }
                  }
                  return label;
                })()}
              >
                <MenuItem
                  key={"all"}
                  onSelect={() => setSelectedFramework(undefined)}
                  active={getSelectedFramework === undefined}
                >
                  All Frameworks
                </MenuItem>
                {ref ? <MenuItem divider /> : null}
                {ref}
                {nonref ? <MenuItem divider /> : null}
                {nonref}
                {groups ? <MenuItem divider /> : null}
                {groups}
              </DropdownButton>
              <div style={{ width: "100%" }} ref={this.searchBarInputRef}>
                <FormControl
                  type="text"
                  value={searchQuery}
                  onChange={this.onKeyUp}
                  placeholder="Search for something..."
                  onFocus={this.handleFocus}
                  onBlur={() =>
                    !this.state.areSuggestionsOvered
                    ? this.handleBlur()
                    : null
                  }
                  style={{ paddingLeft: "20px" }}
                />
              </div>
              {this.areSuggestionsDisplayed ? (
                <div
                  ref={this.suggestionsBoxRef}
                  style={
                    filtersVisible
                      ? styles.autoCompleteFilterOn
                      : styles.autoComplete
                  }
                >
                  {this.suggestionsToDisplay
                    .map((valueTodisplay, index) => {
                      return (
                        <div
                          className={`autocomplete-item ${this.state.arrowSelectedSuggestionIndex === index ? "arrow-selected" : ""}`}
                          key={index}
                          onClick={(e) => {
                            this.handleSuggestionItemsClick(
                              e,
                              valueTodisplay?.toLowerCase()
                            );
                          }}
                          onKeyDown={() => {}}
                        >
                          <Glyphicon glyph="search" style={{ color: "grey" }} />
                          <div style={styles.suggestionItem}>
                            <div style={styles.suggestionLink}>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <div>{valueTodisplay.toLowerCase()}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              ) : null}
              <InputGroup.Button>
                <Button type="submit">
                  <Glyphicon glyph="search" />
                </Button>
              </InputGroup.Button>
            </InputGroup>
          </FormGroup>
        </form>
        <ControlLabel className="filter-toggle" onClick={toggleFilters}>
          <Glyphicon
            glyph={!filtersVisible ? "chevron-right" : "chevron-down"}
          />{" "}
          Filters
        </ControlLabel>
      </div>
    );
  }
}

const SearchBar = memo(withRouter(SearchBarComponent));
export { SearchBar };